import { Youtube } from 'lucide-react';
import { SiFacebook, SiInstagram, SiTiktok } from 'react-icons/si';

interface Props {
  platform: string;
  className?: string;
}

/** One explicit branch per platform; no platform falls back to another's icon. */
export function PlatformGlyph({ platform, className = 'h-3 w-3 shrink-0' }: Props) {
  const common = { className, 'aria-hidden': true as const, 'data-platform': platform };
  if (platform === 'youtube') return <Youtube {...common} />;
  if (platform === 'instagram') return <SiInstagram {...common} />;
  if (platform === 'facebook') return <SiFacebook {...common} />;
  return <SiTiktok {...common} />;
}
